<template>
  <b-card>
    <div style="position: relative">
      <LoadingOverlay :loading="profileScoreLoading" />
      <div class="d-flex align-items-center justify-content-between">
        <h4 class="mb-0">اكتمال معلومات المنظمة</h4>
        <b-button
          @click="syncProfileScore"
          variant="flat-info"
          class="btn-icon rounded-circle"
          size="sm"
          v-b-tooltip.hover.v-info.bottom
          title="تحديث"
        >
          <feather-icon size="18" icon="RefreshCcwIcon" />
        </b-button>
      </div>
      <hr />
      <profile-score-bar
        :requiredBar="profileScore.completion"
        :profileCompletnessBar="profileScore.mark"
        :key="updateKey"
      />
      <hr />
      <score-links-list :links="profileScore.undone" />
    </div>
  </b-card>
</template>

<script>
import ProfileScoreBar from "./ProfileScoreBar.vue";
import { BRow, BCol, VBTooltip, BButton, BCard } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import ScoreLinksList from "./ScoreLinksList.vue";
export default {
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    ProfileScoreBar,
    LoadingOverlay,
    ScoreLinksList,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      updateKey: 0,
    };
  },
  computed: {
    ...mapGetters("NgoProfile", ["profileScoreLoading", "profileScore"]),
  },
  methods: {
    ...mapActions("NgoProfile", ["updateProfileScore", "refreshProfileScore"]),
    syncProfileScore() {
      this.refreshProfileScore().then(() => {
        this.updateKey++;
      });
    },
  },
  created() {
    this.refreshProfileScore().then(() => {
      this.updateKey++;
    });
  },
};
</script>
